<template>
    <div>
        <super-template>
            <template #title>
                Create New Contest
            </template>
            <div
                v-if="entryForm"
                class="w-full"
            >
                <create-contest-form
                    :submit-form="submitForm"
                ></create-contest-form>
            </div>
        </super-template>
    </div>
</template>
<script>
import CreateContestForm from '@/js/components/super/CreateContestForm.vue';
import {ENV_URL, MAIN_URL, STRIPE_PUBLISHABLE} from '../../environment.js';
import axios from 'axios';
import SuperHeader from '@/js/components/super/SuperHeader.vue';
import SuperTemplate from '@/js/components/super/SuperTemplate.vue';

export default {
    components: {
        CreateContestForm,
        SuperHeader,
        SuperTemplate,
    },
    data() {
        console.log('current page', this.$route)
        return {}

    },
    created() {

        this.$store.dispatch('LOADING', true);

        const uri = ENV_URL + this.$route.path;

        this.$store.dispatch('SUPER_CONTESTS_CREATE', {uri: uri}).then(() => {

            this.$store.dispatch('LOADING', false);

        })

    },

    computed: {
        user() {
            return this.$store.state.user;
        },
        entryForm() {
            return this.$store.state.entryForm;
        },
        entry() {
            return this.$store.state.entry;
        },
    },

    mounted() {

    },

    methods: {
        submitForm(data) {
            this.$store.dispatch('LOADING', true);
            let authHeaders = {
                headers: {"Authorization": `Bearer ${this.$store.state.laravelAuthToken}`}
            };
            // /super/contests/{contest}/entries/{id}/update
            let uri = ENV_URL + '/super/contests/create';
            axios.post(uri, data, authHeaders)
                .then((response) => {
                    alert('The new contest was created!');
                    this.$router.push({path: `/super/contests/${response.data.contest.slug}/update`})
                }).finally(() => {
                this.$store.dispatch('LOADING', false);
            });
        },
    },

}
</script>

<style lang="scss">

</style>
